import { ADD_NEW_RTO, ADD_NEW_RTO_ERROR, ADD_NEW_RTO_SUCCESS } from "./Constants"

export const addNewRto = (payload) =>{
    return{
        type: ADD_NEW_RTO,
        payload
    }
}

export const addNewRtoSuccess = (payload) =>{
    return{
        type: ADD_NEW_RTO_SUCCESS,
        payload
    }
}

export const addNewRtoError = (payload) =>{
    return{
        type: ADD_NEW_RTO_ERROR,
        payload
    }
}